module.exports = __webpack_public_path__ + "img/ic_circle_empty.718acaea.svg";